import type { Command, CommandContext } from "./Command";
import type { Vec2 } from "../../world/geometry";
import type { EntityId } from "../../world/Entity";

export class MoveEntityCommand implements Command {
  constructor(
    private readonly entityId: EntityId,
    private readonly position: Vec2,
  ) {}

  execute(context: CommandContext): void {
    context.world.moveEntity(this.entityId, { position: this.position });
    context.events.emit("entity:moved", {
      entityId: this.entityId,
      sceneId: context.world.getCurrentSceneId(),
    });
  }
}
